import { render, staticRenderFns } from "./LaunchpackCustomerInquiry.vue?vue&type=template&id=47b4acda&scoped=true"
import script from "./LaunchpackCustomerInquiry.vue?vue&type=script&lang=js"
export * from "./LaunchpackCustomerInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4acda",
  null
  
)

export default component.exports